export const NUSMOD_API = 'https://api.nusmods.com/v2'